import { consentStore } from './consentStore';

/**
 * Maps trackers to the consent category they require and initializes them when
 * that category is granted.
 *
 * Two invariants:
 *
 * 1. A tracker initializes at most once per page load. Injected tags cannot be
 *    un-injected, so a second init would double-load the tag. Withdrawal is
 *    handled by clearing vendor cookies and reloading the page (see
 *    ConsentPreferences), not by trying to unwind an init.
 * 2. A tracker that throws never prevents another from initializing.
 */
export function createRegistry({ store = consentStore, trackers = [] } = {}) {
  const initialized = new Set();

  function initGranted() {
    for (const tracker of trackers) {
      if (initialized.has(tracker.id) || !store.has(tracker.category)) {
        continue;
      }
      initialized.add(tracker.id);
      try {
        tracker.init();
      }
      catch (error) {
        console.error(`Consent | tracker "${tracker.id}" failed to initialize`, error);
      }
    }
  }

  return {
    start() {
      initGranted();
      return store.subscribe(initGranted);
    },
  };
}
